import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ArrowLeftIcon, CheckCircle2Icon, CheckIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { formatDateTime, priorityClass, priorityLabel } from '../../utils/labels';
export function MemberAnnouncementDetail() {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const {
    announcements,
    currentMember,
    markRead,
    pushToast
  } = useApp();
  const me = currentMember!;
  const a = announcements.find(x => x.id === id);
  if (!a) {
    return <Card className="p-10 text-center" data-id="element-1330" data-mp="18o0h087ktrsv">
        <p className="text-sm font-medium text-ink" data-id="element-1331" data-mp="18qwig6imuym2">Obvestilo ne obstaja.</p>
        <Link to="/clan/obvestila" className="mt-2 inline-block text-[13px] font-medium text-green-600" data-id="element-1332" data-mp="3oeedj7s9m01v">
          Nazaj na obvestila
        </Link>
      </Card>;
  }
  const prebrano = a.prebrali.includes(me.id);
  return <div className="mx-auto max-w-2xl space-y-4" data-id="element-1333" data-mp="2yt1suyactqfu">
      <button onClick={() => navigate(-1)} className="inline-flex items-center gap-1.5 text-[13px] font-medium text-ink-muted transition-colors duration-150 ease-out hover:text-ink" data-id="element-1334" data-mp="2tt5ouz1npz0a">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-1335" data-mp="32s0ua8wvn52j" />
        Nazaj
      </button>

      <Card className="p-6" data-id="element-1336" data-mp="3hpjeqz2iuw46">
        <Badge className={priorityClass[a.prioriteta]} data-id="element-1337" data-mp="3horu2jagqiso">{priorityLabel[a.prioriteta]}</Badge>
        <h1 className="mt-3 text-xl font-semibold leading-snug text-ink" data-id="element-1338" data-mp="3cpx0qnevdbub">{a.naslov}</h1>
        <p className="mt-1.5 text-[13px] text-ink-muted" data-id="element-1339" data-mp="3qimtdaowlf0e">
          {a.avtor} · {formatDateTime(a.objavljeno)} · {a.obcinstvoLabel}
        </p>

        <div className="mt-5 space-y-3 border-t border-line pt-5 text-[15px] leading-relaxed text-ink" data-id="element-1340" data-mp="3miw2z83ah0we">
          {a.besedilo.split('\n\n').map((odstavek, i) => <p key={i} data-id="element-1341" data-mp="3vism6u6wt7k2" data-mpi={i}>{odstavek}</p>)}
        </div>

        {a.zahtevaPotrditev && <div className="mt-6 border-t border-line pt-5" data-id="element-1342" data-mp="2t5cw2a64jxcl">
            {prebrano ? <div className="flex items-center gap-2.5 rounded-lg bg-green-50 px-4 py-3" data-id="element-1343" data-mp="2x4vdux2nfsb7">
                <CheckCircle2Icon className="h-5 w-5 shrink-0 text-green-600" data-id="element-1344" data-mp="324ht1c21fimn" />
                <p className="text-sm font-medium text-green-700" data-id="element-1345" data-mp="36v6loupgelnd">
                  Potrdili ste, da ste obvestilo prebrali.
                </p>
              </div> : <>
                <p className="text-[13px] text-ink-muted" data-id="element-1346" data-mp="3gtdzx5scyplo">
                  Vodstvo prosi za potrditev, da ste obvestilo prebrali.
                </p>
                <Button className="mt-3" full onClick={() => {
            markRead(a.id);
            pushToast('Hvala — potrditev je zabeležena.');
          }} data-id="element-1347" data-mp="3kvr7lzqo0xl3">
                  <CheckIcon className="h-4 w-4" data-id="element-1348" data-mp="1vfrrtzsjk9wh" />
                  Prebral/a sem
                </Button>
              </>}
          </div>}
      </Card>
    </div>;
}